export default () => ({
    consentGiven: false,
})
